<template>
  <mt-popup v-model="moduleState.adjustmentPopup" position="bottom" class="page-module">
    <div class="content-title">
      功能编辑
      <a href="javascript:;" class="close-btn" @click="closeModule()">关闭</a>
    </div>
    <ul class="options">
      <li
        v-for="(item, $index) in items"
        class="item elli"
        :class="{'act': changeIndex === $index}"
        @click="itemSelect(item.type, $index)"
        v-text="item.title + item.val"
      ></li>
    </ul>
    <div class="btns">
      <a href="javascript:;" class="btn" @click="delAdjustment()">删除</a>
      <a href="javascript:;" class="btn affirm" @click="changeAdjustment()">修改</a>
    </div>
  </mt-popup>
</template>

<script>
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import store from '../store/store';
  import {GameData} from '../store/GameData';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: "adjustment_popup",
    computed: {
      ...mapState(['moduleState', 'chapterConfig', 'adjustmentItems'])
    },
    store,
    data() {
      return {
        changeType: null,
        changeIndex: 0,
        items: this.setItems()
      }
    },
    methods: {
      itemSelect(type, i) {
        this.changeType = type;
        this.changeIndex = i;
        Methods.checkChapterHash(105);
      },
      closeModule() {
        Methods.cutComponent([ComponentName.ADJUSTMENT_POPUP], false);
        Methods.checkChapterHash(108);
      },
      setItems() {
        var _items = store.state.adjustmentItems, _res = [], type = null, title = null,
          val = null, _changeType = null;

        for (let i in _items) {
          if (_items[i].type === 'event_change_bgm') {
            title = '背景音乐：';
            type = 'bgm';
          } else if (_items[i].type === 'event_change_bg') {
            title = '背景图片：';
            type = 'bg';
          } else if (_items[i].type === 'event_jump') {
            title = '剧情跳转：';
            type = 'jump';
          } else if (_items[i].type === 'op_number') {
            title = '';
            type = 'num';
          }
          if (i == 0) {
            _changeType = type;
          }
          val = _items[i].des;
          _res.push({title, type, val});
        }
        setTimeout(() => {
          this.changeIndex = 0;
          this.changeType = _changeType;
        }, 0);
        return _res;
      },
      delAdjustment() {
        let _this = this;

        if (_this.changeType !== null) {
          Methods.messageConfirm('', '该功能逻辑将被删除，是否确认？', '确认', '取消', function () {
            _this.items.splice(_this.changeIndex, 1);

            if (_this.items.length <= 0) {
              Methods.cutComponent([ComponentName.ADJUSTMENT_POPUP], false);
            }
            switch (_this.changeType) {
              case 'bg':
                GameData.delEvent("event_change_bg");
                break;
              case 'bgm':
                GameData.delEvent("event_change_bgm");
                break;
              case 'jump':
                GameData.delEvent("event_jump");
                break;
              case 'num':
                GameData.delEvent("op_number", _this.changeIndex);
                break;
            }
            _this.changeIndex = 0;
            _this.changeType = _this.items[0].type;
          }, null);
        }
        Methods.checkChapterHash(106);
      },
      changeAdjustment() {
        let type = null;

        switch (this.changeType) {
          case 'bg':
            type = ComponentName.IMAGE_LIBRARY;
            break;
          case 'bgm':
            type = ComponentName.MUSIC_LIBRARY;
            break;
          case 'jump':
            type = ComponentName.CHAPTER_LIST;
            break;
          case 'num':
            store.state.numericalSwitch = true;
            store.state.numericalType = 'edit';

            let _data = this.adjustmentItems[this.changeIndex];

            Object.assign(_data, {eventIndex: this.changeIndex});
            store.state.numericalEditData = _data;
            return Methods.cutComponent([ComponentName.ADJUSTMENT_POPUP], false);
        }
        Methods.openMaLib(type, 'changeInsert', this.changeCallBack);
        Methods.checkChapterHash(107);
      },
      changeCallBack(name) {
        Vue.set(this.items[this.changeIndex], 'val', name.replace(/bgm\/|.mp3|background\/|.jpg|.png|.gif/g, ''));
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/adjustment_popup.css";
</style>



// WEBPACK FOOTER //
// src/components/adjustment_popup.vue